import { Base } from '../api/base';
import { uia } from '../';
import '@gnyio/interfaces';
export class Uia {
    constructor(connection) {
        this.base = new Base(connection);
    }
    async registerIssuer(name, desc, secret, secondSecret) {
        const trs = uia.registerIssuer(name, desc, secret, secondSecret);
        const params = {
            transaction: trs,
        };
        const res = await this.base.post('/peer/transactions', params);
        const result = res.data;
        return result;
    }
    async registerAsset(name, desc, maximum, precision, secret, secondSecret) {
        const trs = uia.registerAsset(name, desc, maximum, precision, secret, secondSecret);
        const params = {
            transaction: trs,
        };
        const res = await this.base.post('/peer/transactions', params);
        const result = res.data;
        return result;
    }
    async issueAsset(currency, amount, secret, secondSecret) {
        const trs = uia.issue(currency, amount, secret, secondSecret);
        const params = {
            transaction: trs,
        };
        const res = await this.base.post('/peer/transactions', params);
        const result = res.data;
        return result;
    }
    async transfer(currency, amount, recipientId, message, secret, secondSecret) {
        const trs = uia.transfer(currency, amount, recipientId, message, secret, secondSecret);
        const params = {
            transaction: trs,
        };
        const res = await this.base.post('/peer/transactions', params);
        const result = res.data;
        return result;
    }
}
//# sourceMappingURL=uia.js.map